<div class="container-fluid">
  <div class="d-flex justify-content-between gap-2 mb-2">
    <h2 class="mb-0">{{'INDICATOR.TITLE' | translate}}</h2>
    @if (user?.roles.includes('ADMIN') || user?.roles.includes('EDITOR')) {
      <a [routerLink]="['/indicator/add-edit']">
        <button type="button" class="btn btn-primary">{{'FUNCTION-BUTTONS.ADD' | translate}}</button>
      </a>
    }
  </div>
  <nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false" [(activeId)]="activeTabId">
    @for (year of years; track year; let index = $index) {
      <ng-container [ngbNavItem]="index">
        <a ngbNavLink>{{year}}</a>
        <ng-template ngbNavContent>
          <div style="width: 100%; height: 20px;"></div>
          <ntr-datatable [data]="data[year]" [metaInfo]="metaInfo" [entityTitle]="'indicator'" [modelView]="'indicator'"
            [disableHeader]="false"
            (onQuery)="onGridQuery($event)"
            [columns]="columns"
            [extraParameter]="year"
            (onDeleteQuery)="deleteIndicator($event)"
            [canDelete] ="user?.roles.includes('ADMIN') || user?.roles.includes('EDITOR')"
            [userRoles]="user?.roles">
          </ntr-datatable>
        </ng-template>
      </ng-container>
    }
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-0"></div>
</div>
